import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListSumberAir } from "@/services/getData"

export default function MasterSumberAirPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listSumberAir"],
    queryFn: getListSumberAir,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
